import axios from "axios";
import {getMsalIdToken} from '../helpers/localStorageHelper';

function readAccessToken() {
   const token = 'Bearer '+ getMsalIdToken();
    return token || '';
}

function defaultHttpClient() {
    const defaultOptions = {
        baseURL: "https://jobs.intellectualpoint.com/api",
        headers: {
        'Content-Type': 'application/json',
        },
        maxContentLength: 2 * 1024 * 1024, // 2MB
    };
    const instance = axios.create(defaultOptions);
    
    instance.interceptors.request.use(async config => {
        const newConfig = config;
        //newConfig.headers.Authorization = readAccessToken();
        return newConfig;
    });
    

    // instance.interceptors.response.use(
    //     response => {
    //     if (response.status === 221) {
    //         const error = new Error(response?.data?.ErrorMessage);
    //         error.response = response;
    //         return Promise.reject(error);
    //     }
    //     return Promise.resolve(response);
    //     },
    //     error => {
    //     if (error?.response?.status === 401) {
    //         getAuthProvider().sessionExpired();
    //     }
    //     return Promise.reject(error);
    //     }
    // );
    return instance;
}


function jobfairHttpClient() {
const defaultOptions = {
    baseURL: "https://jobs.intellectualpoint.com/api",
    timeout: 2 * 60 * 1000, // 2min
    headers: {
    'Content-Type': 'application/json',
    },
    maxContentLength: 2 * 1024 * 1024, // 2MB
};
const instance = axios.create(defaultOptions);

instance.interceptors.request.use(async config => {
    const newConfig = config;
    newConfig.headers.Authorization = readAccessToken();
    return newConfig;
});

instance.interceptors.response.use(
    response => {
    if (response.status === 221) {
        const error = new Error(response?.data?.ErrorMessage);
        error.response = response;
        return Promise.reject(error);
    }
    return Promise.resolve(response);
    },
    error => {
    if (error?.response?.status === 401) {
        //getAuthProvider().sessionExpired();
    }
    return Promise.reject(error);
    }
);

return instance;
}

function jobfairLogoHttpClient() {
    const defaultOptions = {
        baseURL: "https://jobs.intellectualpoint.com/",
        timeout: 2 * 60 * 1000, // 2min
        headers: {
            Accept: 'application/json',
            'Access-Control-Allow-Origin': '*',
            
        },
        maxContentLength: 2 * 1024 * 1024, // 2MB
    };
    const instance = axios.create(defaultOptions);
    
    instance.interceptors.request.use(async config => {
        const newConfig = config;
        newConfig.headers.Authorization = readAccessToken();
        return newConfig;
    });
    
    instance.interceptors.response.use(
        response => {
        if (response.status === 221) {
            const error = new Error(response?.data?.ErrorMessage);
            error.response = response;
            return Promise.reject(error);
        }
        return Promise.resolve(response);
        },
        error => {
        if (error?.response?.status === 401) {
            //getAuthProvider().sessionExpired();
        }
        return Promise.reject(error);
        }
    );
    
    return instance;
    }

export default {
jobfair: jobfairHttpClient(),
default: defaultHttpClient(),
logo: jobfairLogoHttpClient()
};